import { useCallback } from 'react';
import type { VoidFunctionComponent } from 'react';

import { Category, IssueScopeKind } from '../../../../../shared/issuesV2';
import IssuesSection from '../../../shared/settings/SettingsPageIssueSection';
import Section from '../../../shared/settings/SettingsPageSection';
import SnippetScanningSettingsSection from '../../../shared/settings/SnippetScanningSettingsSection';

import type { IssueSettingsWithSnippetScanning } from './types';

/**
 * ProjectSecurityIssuesSettings
 *
 * Security issue settings for a project
 */
const ProjectSecurityIssuesSettings: VoidFunctionComponent<IssueSettingsWithSnippetScanning> = ({
  isSnippetScanningEnabled,
  onToggleSnippetScanning,
  ...issuesSectionProps
}) => {
  const renderSnippetSettings = useCallback(
    ({ isScanningEnabled, canEditPolicy }) => {
      return (
        <SnippetScanningSettingsSection
          isSnippetScanningEnabled={isSnippetScanningEnabled ?? false}
          onToggleSnippetScanning={onToggleSnippetScanning}
          isScanningEnabled={isScanningEnabled}
          canEditPolicy={canEditPolicy}
          scanType="security"
        />
      );
    },
    [isSnippetScanningEnabled, onToggleSnippetScanning],
  );

  return (
    <Section>
      <Section.Left heading="Security">
        <Section.Paragraph>Configuration for security issues on this project.</Section.Paragraph>
      </Section.Left>
      <Section.Right>
        <IssuesSection
          category={Category.Vulnerability}
          scopeType={IssueScopeKind.Project}
          renderSnippetSettings={renderSnippetSettings}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...issuesSectionProps}
        />
      </Section.Right>
    </Section>
  );
};

export default ProjectSecurityIssuesSettings;
